import { render, staticRenderFns } from "./PointOfSaleList.vue?vue&type=template&id=5805a03d&"
import script from "./PointOfSaleList.vue?vue&type=script&lang=js&"
export * from "./PointOfSaleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports